<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" *ngIf="user" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col noSlider" fxLayout="column">

      <div class="about-cube">
        <app-profile-header [disabled]="true" [profile]="user"></app-profile-header>

        <div class="aboutme-content" fxLayout="column" fxLayoutGap="30px">

          <!-- The tab buttons -->
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px">
            <ng-container *ngFor="let tab of tabs">
              <button *ngIf="tab.visible" [class.light-grey-button]="tab.id === active_tab"
                (click)="setActiveTab(tab.id)">
                {{ tab.label }}
              </button>
            </ng-container>
          </div>

          <ng-container [ngSwitch]="active_tab">

            <!-- A list of the users posts -->
            <ng-container *ngSwitchCase="'posts'">
              <ng-container *ngTemplateOutlet="postsSectionTemplate"></ng-container>
            </ng-container>

            <!-- General information about the user -->
            <ng-container *ngSwitchCase="'info'">
              <ng-container *ngTemplateOutlet="infoSectionTemplate"></ng-container>
            </ng-container>

            <!-- This should never be displayed, because all defined tabs should probably have a view -->
            <ng-container *ngSwitchDefault></ng-container>

          </ng-container>

        </div>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>

<ng-template #postsSectionTemplate>
  <div class="posts-container">
    <ng-container *ngFor="let post of user.posts" [ngSwitch]="post.type">

      <ng-container *ngSwitchCase="'blog'">
        <blog-card [entity]="$any(post).data" data-entitytype="Blog" data-id="{{ post.data.id }}"></blog-card>
      </ng-container>

      <ng-container *ngSwitchCase="'advert'">
        <advert-grid-item [entity]="$any(post).data" data-entitytype="Advert"
          data-id="{{ post.data.id }}"></advert-grid-item>
      </ng-container>

      <ng-container *ngSwitchCase="'job'">
        <job-card [entity]="$any(post).data" data-entitytype="Job" data-id="{{ post.data.id }}"></job-card>
      </ng-container>

    </ng-container>
  </div>
</ng-template>

<ng-template #infoSectionTemplate>

  <!-- NAMES -->
  <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
    <app-about-block-header [title]="'Namen'"></app-about-block-header>

    <!-- firstname -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="!user.use_nickname && user.firstname">
      <div fxFlex="15" class="label">Vorname:</div>
      <div class="label">
        {{ user.firstname }}
      </div>
    </div>

    <!-- lastname -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="!user.use_nickname && user.lastname">
      <div fxFlex="15" class="label">Nachname:</div>
      <div class="label">
        {{ user.lastname }}
      </div>
    </div>

    <!-- nickname -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_nickname">
      <div fxFlex="15" class="label">Nickname:</div>
      <div class="label">
        {{ user.private_nickname }}
      </div>
    </div>
  </div>

  <!-- PERSONAL INFORMATION -->
  <div class="infoblock" fxLayout="column" fxLayoutGap="10px"
    *ngIf="!user.private_personal_information_privacy && typeService.profileObjectFilled(displayStructure['personal'])">
    <app-about-block-header [title]="'Persönliche Informationen'"></app-about-block-header>

    <!-- gender -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_gender">
      <div fxFlex="15" class="label">Geschlecht:</div>
      <div class="label">
        {{ user.private_gender | translate }}
      </div>
    </div>

    <!-- birthday -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_date_of_birth">
      <div fxFlex="15" class="label">Geburtstag:</div>
      <div class="label">
        {{ user.private_date_of_birth }}
      </div>
    </div>
  </div>

  <!-- SOCIAL -->
  <div class="infoblock" fxLayout="column" fxLayoutGap="10px"
    *ngIf="!user.private_social_information_privacy && typeService.profileObjectFilled(displayStructure['social'])">
    <app-about-block-header [title]="'Netzwerk Informationen'"></app-about-block-header>

    <!-- telephone -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_telephone">
      <div fxFlex="15" class="label">Telefon:</div>
      <div class="label">
        {{ user.private_telephone }}
      </div>
    </div>

    <!-- email -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.email">
      <div fxFlex="15" class="label">E-Mail:</div>
      <div class="label">
        {{ user.email }}
      </div>
    </div>

    <!-- website -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_website">
      <div fxFlex="15" class="label">Website:</div>
      <div class="label">
        <a [href]="user.private_website" target="_blank" style="word-break: break-word;">{{ user.private_website }}</a>
      </div>
    </div>

    <!-- facebook -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_facebook">
      <div fxFlex="15" class="label">Facebook:</div>
      <div class="label">
        <a [href]="user.private_facebook" target="_blank" style="word-break: break-word;">{{ user.private_facebook
          }}</a>
      </div>
    </div>
  </div>

  <!-- ADDRESS -->
  <div class="infoblock" fxLayout="column" fxLayoutGap="10px"
    *ngIf="!user.private_address_privacy && typeService.profileObjectFilled(displayStructure['address'])">
    <app-about-block-header [title]="'Adresse'"></app-about-block-header>

    <!-- street -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_street">
      <div fxFlex="15" class="label">Straße:</div>
      <div class="label">
        {{ user.private_street }}
      </div>
    </div>

    <!-- private_street_additional -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_street_additional">
      <div fxFlex="15" class="label">Zusatz:</div>
      <div class="label">
        {{ user.private_street_additional }}
      </div>
    </div>

    <!-- private_zip -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_zip">
      <div fxFlex="15" class="label">PLZ:</div>
      <div class="label">
        {{ user.private_zip }}
      </div>
    </div>

    <!-- private_city -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_city">
      <div fxFlex="15" class="label">Ort:</div>
      <div class="label">
        {{ user.private_city }}
      </div>
    </div>

    <!-- private_state -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_state">
      <div fxFlex="15" class="label">Bundesland:</div>
      <div class="label">
        {{ user.private_state }}
      </div>
    </div>

    <!-- private_country -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_country">
      <div fxFlex="15" class="label">Land:</div>
      <div class="label">
        {{ user.private_country }}
      </div>
    </div>
  </div>

  <!-- CAREER -->
  <div class="infoblock" fxLayout="column" fxLayoutGap="10px"
    *ngIf="!user.private_career_privacy && typeService.profileObjectFilled(displayStructure['career'])">
    <app-about-block-header [title]="'Beruflicher Werdegang'"></app-about-block-header>

    <!-- job -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_job">
      <div fxFlex="15" class="label">Beruf:</div>
      <div class="label">
        {{ user.private_job }}
      </div>
    </div>

    <!-- position -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_job_position">
      <div fxFlex="15" class="label">Position:</div>
      <div class="label">
        {{ user.private_job_position }}
      </div>
    </div>

    <!-- school -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_school">
      <div fxFlex="15" class="label">Schule:</div>
      <div class="label">
        {{ user.private_school }}
      </div>
    </div>

    <!-- employer -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_employer">
      <div fxFlex="15" class="label">Arbeitgeber:</div>
      <div class="label">
        {{ user.private_employer }}
      </div>
    </div>

    <!-- former employers -->
    <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="user.private_former_employers">
      <div fxFlex="15" class="label">Frühere Arbeitgeber:</div>
      <div class="label" style="white-space: pre-line; word-break: break-word;">
        {{ user.private_former_employers }}
      </div>
    </div>
  </div>

  <!-- ABOUTME -->
  <div class="infoblock" fxLayout="column" fxLayoutGap="10px"
    *ngIf="!user.private_about_me && user.private_self_description">
    <app-about-block-header [title]="'Über meinen Werdegang'"></app-about-block-header>

    <div fxLayout="row">
      <div class="label" style="white-space: pre-line; word-break: break-word;">
        {{ user.private_self_description }}
      </div>
    </div>
  </div>

</ng-template>